import { useEffect, useState } from "react";
import { _axios } from "../../utils/axios";

interface Shape {
  id: number;
  name: string;
  image_path: string;
  svg_template?: string;
  category?: string;
}

interface ShapeSelectorProps {
  onSelect: (shape: Shape) => void;
  category?: string;
  selectedShapeId?: number | null;
  selectedType?: string;
}

const ShapeSelector: React.FC<ShapeSelectorProps> = (props) => {
  console.log("🎯 ShapeSelector FULL props received:", props);

  const { onSelect, category, selectedShapeId: selectedShapeIdProp, selectedType: selectedTypeProp } = props;

  const [types, setTypes] = useState<string[]>([]);
  const [shapes, setShapes] = useState<Shape[]>([]);
  const [selectedShapeId, setSelectedShapeId] = useState(
    selectedShapeIdProp ? String(selectedShapeIdProp) : ""
  );
  const [selectedType, setSelectedType] = useState(selectedTypeProp || "");
  console.log("🔧 ShapeSelector props:", {
    category,
    selectedShapeIdProp,
    selectedTypeProp
  });

  useEffect(() => {
    if (category) {
      loadShapes(category);
    } else {
      _axios.get("/schematic/shape-types").then(res => {
        const uniqueCategories = Array.from(new Set(
          res.data
            .map((t: any) => t.category)
            .filter((c: string) => c && c.toUpperCase() !== "DIRECTION")
        )) as string[];
        setTypes(uniqueCategories);
      }).catch(err => {
        console.error("Error loading shape types:", err);
        setTypes([]);
      });
    }
  }, []);

  useEffect(() => {
    console.log("🔄 selectedTypeProp changed:", selectedTypeProp);
    if (!category && selectedTypeProp && selectedTypeProp !== selectedType) {
      console.log("📥 Auto-loading shapes for type:", selectedTypeProp);
      loadShapes(selectedTypeProp);
    }
  }, [selectedTypeProp]);

  useEffect(() => {
    if (selectedShapeIdProp) {
      setSelectedShapeId(String(selectedShapeIdProp));
    }
  }, [selectedShapeIdProp]);

  useEffect(() => {
    if (selectedTypeProp) {
      setSelectedType(selectedTypeProp);
    }
  }, [selectedTypeProp]);

  useEffect(() => {
    if (category === "DIRECTION" && selectedShapeIdProp) {
      loadShapes(category);
    }
  }, [selectedShapeIdProp]);

  const loadShapes = async (type: string) => {
    setSelectedType(type);
    const res = await _axios.get("/schematic/shapes", {
      params: { type }
    });
    setShapes(res.data);
  };

  const handleShapeSelect = (id: string) => {
    setSelectedShapeId(id);
    const selected = shapes.find(s => s.id === Number(id));
    if (selected) {
      onSelect({
        ...selected,
        category: category || selectedType
      });
    }
  };

  return (
    <div className="space-y-3">

      {/* Shape Type */}
      {!category && (
        <select
          className="border rounded-md p-2 w-full text-[#423F3F]"
          value={selectedType}
          onChange={(e) => loadShapes(e.target.value)}
        >
          <option value="">Select Shape Type</option>
          {types.map((t, i) => (
            <option key={i} value={t}>{t}</option>
          ))}
        </select>
      )}

      {/* Shape Name */}
      {shapes.length > 0 && (
        <select
          className="border rounded-md p-2 w-full text-[#423F3F]"
          value={selectedShapeId}
          onChange={(e) => handleShapeSelect(e.target.value)}
        >
          <option value="">
            {category === "DIRECTION" ? "Select Direction" : "Select Shape"}
          </option>

          {shapes.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}

        </select>
      )}

    </div>
  );
};

export default ShapeSelector;